export interface Account {
  id: number
  role: string
  lang: string
  email: string
  study_id: number
  created_at: string
  updated_at: string
  notification: boolean
  communication: boolean
  birthday: string
  name: string
  surname: string
  patient_id: number
  funnel: string
}

export interface IPatient {
  id: number
  surgery_date: string
  surgery_category: string
  recommended: boolean
}

export interface IScore {
  id: number
  patient_id: number
  created_at: string
  updated_at: string
  physical_autonomy: number
  pain_management: number
  life_hygiene: number
  personal_life: number
  professional_life: number
  life_quality: number
  walking: number
  engagement: number
}

export interface IAnalyze {
  id: number
  patient_id: number
  created_at: string
  updated_at: string
  prediction: number
}

export interface IPatientSurvey {
  id: number
  active: boolean
  completed: boolean
  survey_reference: string
  survey_id: number
  start_date: number | null
  end_date: number
  submission: ISubmission
}

export interface ISubmission {
  created_at: string
  answers: Array<IAnswer>
}

export interface IAnswer {
  value: number | string
  question_id: number
}

export interface IStudy {
  id: number
  name: string
  created_at: string
  updated_at: string
  lang: string
  surveys_answered: number
  patients: Array<IPatient>
  scores: Array<IScore>
  analyzes: Array<IAnalyze>
  patient_surveys: Array<IPatientSurvey>
}

export interface IStudyDetails {
  id: number
  name: string
  created_at: string
  updated_at: string
  lang: string
  patient: IPatient
  patient_surveys: Array<IPatientSurvey>
}
export interface IOptions {
  value: number
  label: string
}

export interface IQuestion {
  id: number
  question_reference: string
  content: string
  kind: string
  options: Array<IOptions>
  value: string | undefined
}

export interface ISurvey {
  survey_reference: string
  content: string
  description: string
  kind: string
  questions: Array<IQuestion>
}

export type InvitationPostBody = {
  patient: {
    invitation_token: string
    password: string
    email: string
    name: string
    surname: string
    birthday: string
    recommended: boolean
  }
}

export type InvitationGetResponse = {
  invitation_token: string
}

export type PatientsSurveysGetResponse = Array<IPatientSurvey>
export type SurveysGetResponse = Array<ISurvey>

export type PatientsSurveysSubmissionPostBody = {
  submission: {
    answers_attributes: Array<IAnswer>
  }
}

export type MedicalDocument = {
  id: number
  document_type: string
  comment: string
  created_at: string
  file_url: string
}

export type MedicalDocumentsGetResponse = Array<MedicalDocument>

export type StudiesMap = {
  [key: string]: string
}

export enum BackendModeEnum {
  DEV = "DEV",
  PROD = "PROD"
}

export type Study = {
  id: number
  kind: string
  recommended: boolean
  practitioner: {
    name: string
    surname: string
  }
  administrative_information: {
    name: string
    address: string
    logo_url: string
  }
}

export type PatientPostBody = {
  patient: {
    surgery_category: string
  }
}
